/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 */

import { ON_BROWSER } from '../../../shared/env'
import { populateGeoLocationUrl } from './populateGeoLocationUrl'

export const initializeGeoLocation = (geoLocation) => {
  populateGeoLocationUrl(geoLocation)
  if (ON_BROWSER) {
    return { getGeoLocation: () => geoLocation }
  } else {
    let geoLocationAccessed = false
    return {
      getGeoLocation: () => {
        geoLocationAccessed = true
        return geoLocation
      },
      wasGeoLocationAccessed: () => geoLocationAccessed,
    }
  }
}
